export const CONFIGS = {
  API_END_POINT: process.env.REACT_APP_API_URL,
  ABLEY_API_KEY: process.env.REACT_APP_ABLY_KEY,
};
